import { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useMasterDataContext } from '../../Context/masterDataContext';
import { createNodes } from "../../Api/NodesApi";
import Select from "react-select";


const AddNodes = () => {
  const { roleData,
    loadRoleMaster } = useMasterDataContext();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  console.log("UserId: ", userId);

  console.log(roleData, 'roleData')

  const intitalValues = {
    parentNodeName: "",
    roleIds: [], // 
  }

  const [formValues, setFormValues] = useState(intitalValues);

  const handleChange = (e) => {
    setFormValues({ ...formValues, [e.target.name]: e.target.value });
  };

  const handleMultiple = (name, data) => {
    setFormValues({ ...formValues, [name]: data });
    console.log("cat", data);
  };

  const [childNodes, setchildNodes] = useState([{
    childNodeName: "",
    childNodeRoles: "",
    childNodeUrl: "",
    childStatus: "",
  }]);


  const addChildNodes = (e) => {
    e.preventDefault();
    let object = {
      childNodeName: "",
      childNodeRoles: "",
      childNodeUrl: "",
      childStatus: "",
    };
    setchildNodes([...childNodes, object]);
  };

  const childHandleFormChange = (event, index) => {
    console.log(event, index);
    let data = [...childNodes];
    data[index][event.target.name] = event.target.value;
    setchildNodes(data);
    console.log("childFormFields", childNodes);
  };

  const handleChildMultipleRoles = (index, selectedOptions) => {
    const updatedChildNodes = [...childNodes];
    updatedChildNodes[index].childNodeRoles = selectedOptions;
    setchildNodes(updatedChildNodes);
  };

  const removeFields = (index) => {
    let data = [...childNodes];
    data.splice(index, 1);
    setchildNodes(data);
  };

  const handleSubmit = async (e) => {
    let formDetails = formValues;
    formDetails.child_fields = childNodes;
    e.preventDefault();
    setLoading(true);
    try {
      await createNodes(formDetails, userId);
      toast.success(`🦄 Added Successfully`);
      // setFormValues(intitalValues);
      // navigate("/budgetMaster");
    } catch (error) {
      toast.error(`🦄 Error : ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRoleMaster();
    // fetchRoles()
  }, []);

  // console.log(roleData, 'roleData');

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Add Nodes</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Parent Node<span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="parentNodeName"
                    value={formValues.parentNodeName}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Role List <span className="text-red">**</span></Form.Label>
                  <Select
                    isMulti
                    onChange={(data) => {
                      handleMultiple("roleIds", data);
                    }}
                    options={roleData}
                    value={formValues.roleIds}
                  />
                </Form.Group>
              </Col>
            </Row>

            <h2 className="fields-title">Child Nodes</h2>
            <Button onClick={addChildNodes}>
              Add
            </Button>
            {childNodes.map((childForm, index) => {
              return (
                <>
                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Child Node Name<span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="childNodeName"
                          value={childForm.childNodeName}
                          onChange={(event) =>
                            childHandleFormChange(event, index)
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Role List <span className="text-red">**</span></Form.Label>
                        <Select
                          isMulti
                          onChange={(data) => handleChildMultipleRoles(index, data)}
                          options={roleData}
                          value={childForm.childNodeRoles}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group className="mb-3">
                        <Form.Label>Child Status <span className="text-red">**</span></Form.Label>
                        <Form.Select
                          name="childStatus"
                          value={formValues.childStatus}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="No">
                            No
                          </option>
                          <option value="Yes">
                            Yes
                          </option>

                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group className="mb-3">
                        <Form.Label>Node Url<span className="text-red">**</span></Form.Label>
                        <Form.Control
                          type="text"
                          name="childNodeUrl"
                          value={childForm.childNodeUrl}
                          onChange={(event) =>
                            childHandleFormChange(event, index)
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Button onClick={() => removeFields(index)}>
                        Remove
                      </Button>
                    </Col>

                  </Row>
                </>
              )
            })}



            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Node"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
    </>
  );
};

export default AddNodes